export default __webpack_public_path__ + "static/media/ump45.13058986.svg";